"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccountAgreementDocTypeForLoanApplicationType = void 0;
const assertUtils_1 = require("../assertUtils");
const loanApplication_1 = require("../origination/loanApplication");
const documentName_1 = require("./documentName");
const getAccountAgreementDocTypeForLoanApplicationType = (applicationType) => {
    switch (applicationType) {
        case loanApplication_1.LoanApplicationType.AVEN_UCC_ORIGINATION:
        case loanApplication_1.LoanApplicationType.AVEN_UCC_ORIGINATION_DRYRUN:
            return documentName_1.DocumentName.UccAccountAgreement;
        case loanApplication_1.LoanApplicationType.AVEN_ORIGINATION:
        case loanApplication_1.LoanApplicationType.AVEN_ORIGINATION_DRYRUN:
        case loanApplication_1.LoanApplicationType.AVEN_MLO_ORIGINATION:
        case loanApplication_1.LoanApplicationType.AVEN_HOME_REATTACH:
            return documentName_1.DocumentName.AccountAgreement;
        case loanApplication_1.LoanApplicationType.AVEN_DEPOSIT_ORIGINATION:
            return documentName_1.DocumentName.DepositAccountAgreement;
        case loanApplication_1.LoanApplicationType.AVEN_HOME_REUNDERWRITING_LINE_SIZE_INCREASE:
        case loanApplication_1.LoanApplicationType.AVEN_HOME_REUNDERWRITING_LINE_SIZE_INCREASE_DRYRUN:
        case loanApplication_1.LoanApplicationType.AVEN_HOME_REUNDERWRITING_APR_REDUCTION:
        case loanApplication_1.LoanApplicationType.AVEN_HOME_CLI_AND_APR_REDUCTION_AND_BALANCE_SWEEP:
        case loanApplication_1.LoanApplicationType.AVEN_HOME_CLI_AND_APR_REDUCTION_AND_BALANCE_SWEEP_DRYRUN:
        case loanApplication_1.LoanApplicationType._AVEN_WAITLIST:
        case loanApplication_1.LoanApplicationType._AVEN_HOME_REUNDERWRITING_ANNUAL_RENEWAL:
        case loanApplication_1.LoanApplicationType._MORTGAGE_BROKERING:
        case loanApplication_1.LoanApplicationType.AVEN_HOME_REUNDERWRITING_POLICY_CHANGE:
        case loanApplication_1.LoanApplicationType.AVEN_UCC_REUNDERWRITING_LINE_SIZE_INCREASE:
        case loanApplication_1.LoanApplicationType.AVEN_UCC_REUNDERWRITING_LINE_SIZE_INCREASE_DRYRUN:
        case loanApplication_1.LoanApplicationType.AVEN_UCC_REUNDERWRITING_CLI_NO_HARD_PULL_NO_COMMS:
        case loanApplication_1.LoanApplicationType.AVEN_MORTGAGE_ORIGINATION:
        case loanApplication_1.LoanApplicationType.AVEN_CRYPTO_ORIGINATION:
        case loanApplication_1.LoanApplicationType.AVEN_CRYPTO_REUNDERWRITING:
            throw new Error(`LoanApplicationType ${applicationType} does not have an account agreement`);
        default:
            throw (0, assertUtils_1.assertNever)(applicationType, `Unhandled LoanApplicationType: ${applicationType}`);
    }
};
exports.getAccountAgreementDocTypeForLoanApplicationType = getAccountAgreementDocTypeForLoanApplicationType;
